import { useState } from "react";
import EmojiPicker from "emoji-picker-react";
import ImageIcon from '@mui/icons-material/Image';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
// import "../scss/chatInput.scss";

const ChatInput = ({ 
    text, setText, 
    isDisabled, 
    isSending,
    cooldown,
    onSend, 
    onFileSelect, 
    isRecording, 
    toggleRecording 
}) => {
    const [openEmoji, setOpenEmoji] = useState(false);

    const handleEmoji = (e) => {
        setText((prev) => prev + e.emoji);
        setOpenEmoji(false);
    }

    return (
        <div className="inputArea">
            <div className="icons">
                <label htmlFor="file" style={{ opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? "none" : "auto" }}>
                    <ImageIcon />
                </label>

                <input
                    type="file" id="file" multiple
                    style={{ display: "none" }}
                    onChange={onFileSelect}
                    disabled={isDisabled}
                />

                <label htmlFor="file" style={{ opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? "none" : "auto" }}>
                    <AttachFileIcon />
                </label>
                
                <div 
                    onClick={toggleRecording} 
                    className={`micIcon ${isRecording ? 'recording' : ''}`}
                    style={{ opacity: isDisabled ? 0.5 : 1, cursor: isDisabled ? "not-allowed" : "pointer" }}
                >
                    {isRecording ? <StopIcon sx={{color: 'red'}} /> : <MicIcon />}
                </div>
            </div>

            <input
                type="text"
                placeholder={isDisabled && cooldown > 0 ? `Please wait ${cooldown}s...` : (isDisabled ? "Cannot send message" : "Type a message...")}
                value={text}
                onChange={(e) => setText(e.target.value)}
                disabled={isDisabled}
                onKeyDown={(e) => e.key === "Enter" && onSend()}
            />

            <div className="emoji">
                <EmojiEmotionsIcon 
                    onClick={() => setOpenEmoji((prev) => !prev)} 
                    style={{ opacity: isDisabled ? 0.5 : 1, cursor: isDisabled ? "not-allowed" : "pointer" }}
                />
                {openEmoji && !isDisabled && (
                    <div className="picker">
                        <EmojiPicker open={openEmoji} onEmojiClick={handleEmoji} />
                    </div>
                )}
            </div>

            <button className="sendButton" onClick={onSend} disabled={isDisabled}>
                {cooldown > 0 ? `Wait ${cooldown}s` : (isSending ? "Sending..." : "Send")}
            </button>
        </div>
    );
};

export default ChatInput;